// extracted by mini-css-extract-plugin
export default {"productGallery":"PJ-z","inQuickShop":"QJ-z"};